// Generated by volt_bundle from *.volt-entrypoint.tsx discovery. Do not edit.
import type { Entrypoint } from '@townsquare/router/volt/types';

import ProjectPageEntrypoint from '@townsquare/project-view/entrypoint';

const entrypointRegistry: Record<string, Entrypoint> = {
	ProjectPageEntrypoint,
};

export default entrypointRegistry;
